import { useDispatch } from 'react-redux';
import _ from 'lodash';//libreria con funciones, por convención se usa con _
import { setConfig, initStore } from '../actions';
import { getQS } from './utilerias-components';



const getColorIps = () => {
    return {
        mod:'#ffea00',
        low:'#ff5400'
    }
}

export default ({ children, config }) => {
    //inicializa variables recibidas por url o por el metodo Init
    const dispatch = useDispatch();
    const [path, ui, ag, idt] = getQS();
    config.isLoading = true;
    config.path = config.path ?? path;
    config.ui = ui ?? '';
    config.ag = ag ?? '';
    config.idt = idt ?? ''; 
    config.color = getColorIps();
    config.appElement= config.appElement;
    dispatch(setConfig(config))
    dispatch(initStore());
    //config.varTime = config.varTime ?? 'Periodo';

    return children;
}
